const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export async function apiFetch(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', 'X-API-Key': process.env.REACT_APP_API_KEY },
    ...options,
  });
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  return res.json();
}

export const api = {
  // Accounts
  getAccounts:      ()     => apiFetch('/api/accounts'),
  saveAccounts:     (data) => apiFetch('/api/accounts',          { method: 'POST', body: JSON.stringify(data) }),

  // Net worth history
  getHistory:       ()     => apiFetch('/api/net-worth-history'),
  saveHistory:      (data) => apiFetch('/api/net-worth-history', { method: 'POST', body: JSON.stringify(data) }),

  // Income
  getIncome:        ()     => apiFetch('/api/income'),
  saveIncome:       (data) => apiFetch('/api/income',            { method: 'POST', body: JSON.stringify(data) }),

  // Contributions
  getContributions: ()     => apiFetch('/api/contributions'),
  saveContributions:(data) => apiFetch('/api/contributions',     { method: 'POST', body: JSON.stringify(data) }),

  // Wheel
  getTrades:        ()     => apiFetch('/api/wheel/trades'),
  saveTrade:        (data) => apiFetch('/api/wheel/trades',      { method: 'POST', body: JSON.stringify(data) }),
  getShares:        ()     => apiFetch('/api/wheel/shares'),
  saveShares:       (data) => apiFetch('/api/wheel/shares',      { method: 'POST', body: JSON.stringify(data) }),

  // Health
  getWeight:        ()     => apiFetch('/api/health/weight'),
  saveWeight:       (data) => apiFetch('/api/health/weight',     { method: 'POST', body: JSON.stringify(data) }),
  getLabs:          ()     => apiFetch('/api/health/labs'),
  saveLabs:         (data) => apiFetch('/api/health/labs',       { method: 'POST', body: JSON.stringify(data) }),

  // Meditation
  getMeditation:    ()     => apiFetch('/api/meditation'),
  saveMeditation:   (data) => apiFetch('/api/meditation',        { method: 'POST', body: JSON.stringify(data) }),

  // Habits
  getHabits:        ()     => apiFetch('/api/habits'),
  getBooks:         ()     => apiFetch('/api/books'),

  // Goals
  getGoals:         ()     => apiFetch('/api/goals'),
  saveGoals:        (data) => apiFetch('/api/goals',             { method: 'POST', body: JSON.stringify(data) }),

  // Settings
  getSettings:      ()     => apiFetch('/api/settings'),
  saveSettings:     (data) => apiFetch('/api/settings',          { method: 'POST', body: JSON.stringify(data) }),
};
